module.exports = (__webpack_require__(4))(1720);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-router/es/Switch.js from dll-reference vendorProd_library
// module id = 647
// module chunks = 42